import type React from "react";

const SET_MEDIA_REF = "SET_MEDIA_REF" as const;
const SET_PLAYER_REF = "SET_PLAYER_REF" as const;

export type SetMediaRefAction = {
  type: typeof SET_MEDIA_REF;
  payload: {
    mediaRef: React.MutableRefObject<
      HTMLVideoElement | HTMLAudioElement | null
    > | null;
  };
};
export const setMediaRef = (
  mediaRef: React.MutableRefObject<
    HTMLVideoElement | HTMLAudioElement | null
  > | null
): SetMediaRefAction => ({
  type: SET_MEDIA_REF,
  payload: {
    mediaRef,
  },
});

export type SetPlayerRefAction = {
  type: typeof SET_PLAYER_REF;
  payload: {
    playerRef: React.MutableRefObject<HTMLDivElement | null> | null;
  };
};

export const setPlayerRef = (
  playerRef: React.MutableRefObject<HTMLDivElement | null> | null
): SetPlayerRefAction => ({
  type: SET_PLAYER_REF,
  payload: {
    playerRef,
  },
});

export type ActionType = SetMediaRefAction | SetPlayerRefAction;

export const actions = {
  setMediaRef,
};

export const actionTypeLiterals = {
  SET_MEDIA_REF,
};

export type State = {
  mediaRef: React.MutableRefObject<
    HTMLVideoElement | HTMLAudioElement | null
  > | null;
  playerRef: React.MutableRefObject<HTMLDivElement | null> | null;
};

export const initialState: State = {
  mediaRef: null,
  playerRef: null,
};

export const reducer = (state: State, action: ActionType): State => {
  switch (action.type) {
    case SET_MEDIA_REF:
      return {
        ...state,
        mediaRef: action.payload.mediaRef,
      };
    case "SET_PLAYER_REF":
      return {
        ...state,
        playerRef: action.payload.playerRef,
      };
    default:
      return state;
  }
};
